module.exports = __webpack_public_path__ + "img/dp-sy-bm7.4dd0f18a.png";